import { usuarios } from '@/services/usuarios'

export default {
	getProfiles: (context) => {
		usuarios.findPerfis()
			.then(res => context.commit('LOAD_PROFILES', res.data))
	}
}
